import { render, staticRenderFns } from "./company-terms.vue?vue&type=template&id=238f49d6&scoped=true&lang=pug"
import script from "./company-terms.vue?vue&type=script&lang=ts"
export * from "./company-terms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f49d6",
  null
  
)

export default component.exports